export default "__VITE_ASSET__MfM4JdVj__"